import loadable from "@loadable/component";
import React from "react";

import useStores from "@hooks/useStores";
import useError from "@hooks/useError";
import useStaticContext from "@hooks/useStaticContext";

import Header from "../../Shared/Header";
import Footer from "../../Shared/Footer";

import useStyles from "@hooks/useStyles";
import { compose } from "recompose";
import withStyles from "@framework/src/libs/withStyles";
import styles from "@components/Dashboard/Pro/Funnel/.styles";

import theme from "@src/styles/theme";

import Box from "@material-ui/core/Box";
import Container from "@material-ui/core/Container";
import Grid from "@material-ui/core/Grid";
import WbIncandescentOutlinedIcon from "@material-ui/icons/WbIncandescentOutlined";
import Button from "@material-ui/core/Button";
import AddCircleOutlineIcon from "@material-ui/icons/AddCircleOutline";
import Avatar from "@material-ui/core/Avatar";
import Rating from "@material-ui/lab/Rating";
import StarBorderIcon from "@material-ui/icons/StarBorder";
import LinkOutlinedIcon from "@material-ui/icons/LinkOutlined";

import TextField from "@components/Global/Custom/TextField";

const { BRAND_NAME } = process.env;

const Reviews = compose(withStyles(styles))(() => {
	const classes = useStyles("Funnel");

	return (
		<React.Fragment>
			<Header label={"Build a winning profile"} />

			<Box
				component={"div"}
				className={classes.funnelWrapper}
				bgcolor={"#FAFAFA"}
			>
				<Container maxWidth={"md"} className={classes.funnelContainer}>
					<Box pb={8}>
						<Box
							component={"div"}
							fontWeight={700}
							className={classes.funnelHeader}
							pb={4}
						>
							Get at least 1 review from past customers.
						</Box>

						<Box component={"div"} lineHeight={1.5}>
							Reviews are very important. They show new customers how excited
							people are about working with you.
						</Box>
					</Box>

					<Grid container spacing={6}>
						<Grid item xs={12} sm={7}>
							<form>
								<Grid container spacing={6}>
									<Grid item xs={12} md={10}>
										<Box component="div" mb={2} fontWeight={700}>
											Send past customers an email
										</Box>

										<Box mb={4}>
											<TextField
												type="email"
												variant="outlined"
												fullWidth
												required
												autoCorrect="off"
												id="review-email"
												placeholder="Email 1"
												name="review-email"
												inputProps={{
													autoCorrect: "off",
													spellCheck: "false",
												}}
												aria-label="Enter email address of past customers"
											/>
										</Box>
										<div>
											<Button
												size={"large"}
												color={"primary"}
												startIcon={<AddCircleOutlineIcon />}
											>
												Add customer
											</Button>
										</div>
									</Grid>
									<Grid item xs={12} md={10}>
										<Box component="div" mb={2} fontWeight={600}>
											Email preview
										</Box>
										<Box
											borderRadius={4}
											boxShadow={1}
											p={6}
											bgcolor={"#FFFFFF"}
											display={"flex"}
											alignItems={"center"}
											justifyContent={"center"}
											flexDirection={"column"}
										>
											<Avatar
												alt="Remy Sharp"
												src="/static/images/avatar/1.jpg"
												style={{ width: 80, height: 80 }}
											/>

											<Box mb={4} mt={4} fontWeight={700}>
												Texas Lawn Masters
											</Box>
											<Box component={"div"} mb={4} fontWeight={700}>
												<Rating
													name="half-rating-read"
													value={5}
													precision={0.5}
													size="large"
													readOnly
													icon={<StarBorderIcon fontSize="inherit" />}
												/>
											</Box>
											<Box component={"div"} fontSize={14} lineHeight={1.7}>
												Thanks for being a valued customer. I just signed up on{" "}
												{BRAND_NAME} to find more excellent customers like you,
												and reviews are a big part of my profile. Can you take a
												moment to write a couple sentences about working with
												me? I’d love if my future customers could hear about
												your experience firsthand.
												<br />
												<br />
												Thanks, Texas Lawn Masters
											</Box>
										</Box>

										<Box mt={6}>
											<Button
												size={"large"}
												color={"primary"}
												startIcon={<LinkOutlinedIcon />}
											>
												Copy sharable link
											</Button>
										</Box>
									</Grid>
								</Grid>
							</form>
						</Grid>

						<Grid item xs={12} sm={5}>
							<Box borderRadius={4} boxShadow={1} p={6} bgcolor={"#FFFFFF"}>
								<Box mb={2}>
									<WbIncandescentOutlinedIcon
										fontSize={"large"}
										style={{
											color: theme.palette.warning.main,
											transform: "rotate(180deg)",
										}}
									/>
								</Box>
								<Box component={"div"} mb={4} fontWeight={700}>
									Reviews make you competitive
								</Box>
								<Box component={"div"} fontSize={14}>
									Math Tutors in your area have an average of 26 reviews.
								</Box>
							</Box>
						</Grid>
					</Grid>
				</Container>
			</Box>

			<ErrorTemplate />

			<Footer label={"Send request"} continueHandler={continueHandler} />
		</React.Fragment>
	);
});

export default Reviews;
export const loader = (route) =>
	loadable(() => import("./Reviews.component"), { ssr: !!route.ssr });
